import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  MenuItem,
  Dialog,
  FormControlLabel,
  Checkbox,
  useTheme,
  useMediaQuery,
  DialogContent,
  DialogActions,
  DialogContentText,
  SelectChangeEvent,
  FormControl,
  Select,
  ListItemText,
  TablePagination,
} from "@mui/material";
import {
  useGetAllPolicyGroupByQuery,
  useGetCustomerNewsLetterQuery,
  useGetClientTypeQuery,
  useCreateNewsletterSmsClientMutation,
  useCreateNewsletterEmailClientMutation,
} from "../../../Api/attoDeskApi";
import {
  IClientType,
  ICustomer,
  IPolicy,
} from "../../../Api/Interface/api.interface";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridRowSelectionModel,
  GridPaginationModel,
} from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import TableViewIcon from "@mui/icons-material/TableView";
import * as XLSX from "xlsx";
import {
  ClientSource,
  ClientStatus,
  Gender,
  MaritalStatus,
} from "../../../Core/Enum/enum";
import dayjs from "dayjs";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import "react-quill/dist/quill.snow.css";
import PreviewIcon from "@mui/icons-material/Preview";
import SendIcon from "@mui/icons-material/Send";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

function getGenderLabel(genderId: string) {
  switch (genderId) {
    case Gender.Male:
      return "Male";
    case Gender.Female:
      return "Female";
    case Gender.Other:
      return "Other";
    default:
      return "";
  }
}

function getMaritalStatusLabel(maritalStatusId: string) {
  switch (maritalStatusId) {
    case MaritalStatus.Single:
      return "Single";
    case MaritalStatus.Married:
      return "Married";
    case MaritalStatus.Divorced:
      return "Divorced";
    case MaritalStatus.Widowed:
      return "Widowed";
    default:
      return "";
  }
}

function getClientStatus(customerClientStatusId: string) {
  switch (customerClientStatusId) {
    case ClientStatus.Active:
      return "Active";
    case ClientStatus.Inactive:
      return "Inactive";
    case ClientStatus.Pending:
      return "Pending";
    case ClientStatus.Closed:
      return "Closed";
    default:
      return "";
  }
}

function getClientSource(customerClientSource: string) {
  switch (customerClientSource) {
    case ClientSource.Referral:
      return "Referral";
    case ClientSource.Website:
      return "Website";
    case ClientSource.WalkIn:
      return "WalkIn";
    case ClientSource.CallCenter:
      return "CallCenter";
    case ClientSource.Email:
      return "Email";
    case ClientSource.SocialMedia:
      return "SocialMedia";
    default:
      return "";
  }
}

const toAllCaps = (text: string | null | undefined): string => {
  if (!text) return "";
  return text.toUpperCase();
};

const allColumns = [
  "Client Id",
  "Client Type",
  "Client Name",
  "Cell Phone Number",
  "Work Phone Number",
  "E-mail",
  "Address",
  "Gender",
  "Marital Status",
  "Date Of Birth",
  "Prefer Time to Call",
  "Client Status",
  "Client Source",
  "Contact Stage",
  "Referred By",
];

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 100,
  });
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [selectedClient, setSelectedClient] = useState<number[]>([]);
  const [selectedPolicy, setSelectedPolicy] = useState<number[]>([]);

  const [selectedClientCat, setSelectedClientCat] = useState<string>("All");
  const [selectedClientPerent, setSelectedClientPerent] =
    useState<string>("policyOwner");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [policyData, setPolicyData] = useState<IPolicy[]>([]);
  const [isOwnPolicy, setIsOwnPolicy] = useState<string>("");
  const [message, setMessage] = useState("");
  const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
  const [selectedRowIds, setSelectedRowIds] = useState<GridRowSelectionModel>(
    []
  );
  const [isPaperVisible, setIsPaperVisible] = useState(false);

  const { data: clientData, isLoading: cilentIsLoading } =
    useGetClientTypeQuery({
      searchText: "",
      id: "",
    });

  const handleOpen = () => {
    setSelectedColumns(allColumns);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleClose1 = () => setOpen1(false);

  const { data, isLoading, isError, refetch } = useGetCustomerNewsLetterQuery({
    searchText: currentSearchQuery,
    id: "",
    // isParentFilter: selectedClientCat,
    isPolicyOwnAndBenifiOnly: selectedClientPerent,
    customerClientId: selectedClient,
    policyTypeIds: selectedPolicy,
  });

  const {
    data: policyGroupData,
    isLoading: policyIsLoading,
    isError: policyIsError,
    refetch: policyRefetch,
  } = useGetAllPolicyGroupByQuery({
    searchText: "",
    id: "",
    policyCustomerId: "",
  });

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleCheckboxChange = (column: string) => {
    setSelectedColumns((prev) =>
      prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column]
    );
  };

  const cliendList = useMemo(() => {
    return (clientData?.data ?? []) as IClientType[];
  }, [clientData?.data]);

  const policyDataList = useMemo(() => {
    return (policyGroupData?.data ?? []) as IPolicy[];
  }, [policyGroupData?.data]);

  const clientTypeMap = useMemo(() => {
    const map = new Map();
    cliendList?.forEach((category) => {
      map.set(category.id, category.client_type);
    });
    return map;
  }, [cliendList]);

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setSelectedColumns(allColumns);
    } else {
      setSelectedColumns([]);
    }
  };

  const hadelSelectAllClitntType = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setSelectedClient(cliendList.map((category) => category.id));
    } else {
      setSelectedClient([]);
    }
  };

  const hadelSelectAllPolicy = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedPolicy(policyDataList.map((category) => category.id));
    } else {
      setSelectedPolicy([]);
    }
  };

  const coursings: ICustomer[] = Array.isArray(data?.data)
    ? (data?.data as ICustomer[])
    : [];

  const handleIsClientPerent = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedClientPerent(selectedValues);
  };

  const handleAddClientType = () => {
    navigate("/client/newsletters/list");
  };

  const handleEmailNavigate = () => {
    if (selectedRowIds.length > 0) {
      navigate(`/client/newsletter/e-mail?ids=${selectedRowIds.join(",")}`);
    }
  };

  const handleSmsNavigate = () => {
    if (selectedRowIds.length > 0) {
      navigate(`/client/newsletter/sms?ids=${selectedRowIds.join(",")}`);
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const columns: GridColDef[] = [
    {
      field: "customerName",
      headerName: "Client Name",
      minWidth: 200,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Link
          to={`/profile/customer/${params.row.id}`}
          className={classes.iconLinkPropNormal}
        >
          <span
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
            // onClick={() => navigate(`/profile/customer/${params.row.id}`)}
          >
            {`${toProperCase(params.row.customerFirstName)} ${toProperCase(
              params.row.customerLastName
            )}`}
            <FontAwesomeIcon icon={faUser} style={{ color: "#1976d2" }} />
          </span>
        </Link>
      ),
    },
    {
      field: "customerMobileNum",
      headerName: "Mobile Number",
      minWidth: 200,
      flex: 1,
      renderCell: (params: GridRenderCellParams) =>
        formatPhoneNumberForDisplay(params.row.customerMobileNum),
    },
    {
      field: "customerEmail",
      headerName: "E-mail",
      minWidth: 200,
      flex: 1,
    },
  ];

  const formattedRows = coursings.map((row: ICustomer) => ({
    id: row.id,
    customerRefId: row.customerRefId,
    customerFirstName: row.customerFirstName,
    customerLastName: row.customerLastName,
    customerMobileNum: row.customerMobileNum,
    customerEmail: (row.customerEmail || "").trim().toLowerCase(),
    // customerClientId: row.customerClientId,
    customerAddresLine: row.customerAddresLine,
    customerCity: row.customerCity,
    customerProvince: row.customerProvince,
    customerPostalCode: row.customerPostalCode,
  }));

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

  const handleRowSelection = (selectionModel: GridRowSelectionModel) => {
    setSelectedRowIds(selectionModel);
  };

  const handleExport = () => {
    handleExportExcel(selectedColumns);
    handleClose();
  };

  const handleExportExcel = (selectedCols: string[]) => {
    const coursings: ICustomer[] = Array.isArray(data?.data)
      ? (data?.data as ICustomer[])
      : [];

    const selectedRows = coursings.filter((row) =>
      selectedRowIds.includes(row.id)
    );

    if (selectedRows.length === 0) {
      alert("Please select at least one row to export!");
      return;
    }
    const fullExcelData = selectedRows.map((row) => ({
      "Client Id": row.customerRefId || "",
      "Client Type": clientTypeMap.get(Number(row.customerClientId)) || "",
      "Client Name":
        `${toProperCase(row.customerFirstName || "")} ${toProperCase(
          row.customerLastName || ""
        )}`.trim() || "",
      "Work Phone Number":
        formatPhoneNumberForDisplay(row.customerWorkMobileNum) || "",
      "Home Phone Number":
        formatPhoneNumberForDisplay(row.customerHomeMobileNum) || "",
      "Cell Phone Number":
        formatPhoneNumberForDisplay(row.customerMobileNum) || "",
      "E-mail": (row.customerEmail || "").toLowerCase() || "",
      Address:
        [
          toProperCase(row.customerAddresLine || ""),
          toProperCase(row.customerCity || ""),
          toAllCaps(row.customerProvince || ""),
          toAllCaps(row.customerPostalCode || ""),
        ]
          .filter(Boolean)
          .join(", ") || "",
      "Date Of Birth": row.customerDateOfBirth
        ? dayjs(row.customerDateOfBirth).format("MMM D, YYYY")
        : "",
      Gender: row.customerGenderId ? getGenderLabel(row.customerGenderId) : "",
      "Marital Status": row.customerMaritalStatusId
        ? getMaritalStatusLabel(row.customerMaritalStatusId)
        : "",
      "Prefer Time to Call":
        capitalizeFirstLetter(row.customerPreferTimeToCall || "") || "",
      "Client Status": row.customerClientStatusId
        ? getClientStatus(row.customerClientStatusId)
        : "",
      "Client Source": row.customerClientSource
        ? getClientSource(row.customerClientSource)
        : "",
      "Contact Stage": capitalizeFirstLetter(row.customerContactStage || ""),
      "Referred By": capitalizeFirstLetter(row.customerHeight || ""),
    }));

    const filteredExcelData = fullExcelData.map((row) => {
      const filteredRow: any = {};
      selectedCols.forEach((col) => {
        filteredRow[col] = row[col as keyof typeof row];
      });
      return filteredRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredExcelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Client");
    const today = dayjs();
    const formattedDate = today.format("MMM, DD YYYY (dddd)");
    const filename = `Client_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, filename);
  };

  const isAllSelected = selectedColumns.length === allColumns.length;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPaginationModel((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = parseInt(event.target.value, 10);
    setPaginationModel({ page: 0, pageSize: value });
  };

  const resetFields = () => {
    setSelectedClientPerent("1");
    setSelectedClient([]);
    setSelectedPolicy([]);
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              {/* <Grid item sx={{ display: "flex", justifyContent: "flex-start" }}>
          <Grid
            container
            spacing={1}
            justifyContent="flex-start"
            sx={{ display: "flex" }}
          >
            <Grid item>
              <FormControl fullWidth size="small" sx={{ width: 250 }}>
                <InputLabel id="demo-multiple-checkbox-label-benif">
                  Client/Bene
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label-benif"
                  id="demo-multiple-checkbox-benif"
                  input={<OutlinedInput label="Client Type" />}
                  MenuProps={MenuProps}
                  value={selectedClientPerent}
                  onChange={handleIsClientPerent}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="1">Client</MenuItem>
                  <MenuItem value="0">Beneficiaries</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl fullWidth size="small" sx={{ width: 250 }}>
                <InputLabel id="demo-multiple-checkbox-label">
                  Client Type
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  input={<OutlinedInput label="Client Type" />}
                  MenuProps={MenuProps}
                  value={selectedClient}
                  onChange={(
                    event: SelectChangeEvent<typeof selectedClient>
                  ) => {
                    const { value } = event.target;
                    setSelectedClient(
                      typeof value === "string"
                        ? value.split(",").map(Number)
                        : value
                    );
                  }}
                  renderValue={(selected) =>
                    selected
                      .map((id) => {
                        const item = cliendList.find((c) => c.id === id);
                        return item ? item.client_type : id;
                      })
                      .join(", ")
                  }
                >
                  <MenuItem>
                    <Checkbox
                      checked={selectedClient.length === cliendList.length}
                      onChange={hadelSelectAllClitntType}
                    />
                    <ListItemText primary="Select All" />
                  </MenuItem>
                  {cliendList &&
                    cliendList.map((category) => (
                      <MenuItem key={category.id} value={category.id}>
                        <Checkbox
                          checked={selectedClient.indexOf(category.id) > -1}
                        />
                        <ListItemText primary={category.client_type} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl fullWidth size="small" sx={{ width: 250 }}>
                <InputLabel id="demo-multiple-checkbox-label-policy">
                  Policy Type
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label-policy"
                  id="demo-multiple-checkbox-policy"
                  multiple
                  input={<OutlinedInput label="Policy Type" />}
                  MenuProps={MenuProps}
                  value={selectedPolicy}
                  onChange={(
                    event: SelectChangeEvent<typeof selectedPolicy>
                  ) => {
                    const { value } = event.target;
                    setSelectedPolicy(
                      typeof value === "string"
                        ? value.split(",").map(Number)
                        : value
                    );
                  }}
                  renderValue={(selected) =>
                    selected
                      .map((id) => {
                        const item = policyDataList.find((c) => c.id === id);
                        return item ? item.policyNumber : id;
                      })
                      .join(", ")
                  }
                >
                  <MenuItem>
                    <Checkbox
                      checked={selectedPolicy.length === policyDataList.length}
                      onChange={hadelSelectAllPolicy}
                    />
                    <ListItemText primary="Select All" />
                  </MenuItem>
                  {policyDataList &&
                    policyDataList.map((category) => (
                      <MenuItem key={category.id} value={category.id}>
                        <Checkbox
                          checked={selectedPolicy.indexOf(category.id) > -1}
                        />
                        <ListItemText primary={category.policyNumber} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Mobile & Name .."
                size="small"
                className={classes.searchTextField}
              />
            </Grid>
          </Grid>
        </Grid> */}

              <Grid item sx={{ display: "flex", justifyContent: "flex-start" }}>
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-start"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <Button
                      // variant="contained"
                      startIcon={<TableViewIcon />}
                      className={classes.addNewButton}
                      onClick={handleOpen}
                      disabled={!selectedRowIds.length}
                    >
                      Excel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      className={classes.addButton}
                      onClick={handleToggle}
                    >
                      {isPaperVisible ? "Close Filter" : "Open Filter"}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                // lg={12}
                // md={12}
                // sm={12}
                // xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <Button
                      startIcon={<MailOutlineIcon />}
                      className={classes.addNewButton}
                      onClick={handleEmailNavigate}
                      disabled={selectedRowIds.length === 0}
                    >
                      E-mail
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      startIcon={<SmsOutlinedIcon />}
                      className={classes.addNewButton}
                      onClick={handleSmsNavigate}
                      disabled={selectedRowIds.length === 0}
                    >
                      SMS
                    </Button>
                  </Grid>

                  <Grid item>
                    <Link
                      to={`/client/newsletters/list`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        startIcon={<PreviewIcon />}
                        className={classes.addNewButton}
                        onClick={handleAddClientType}
                      >
                        History
                      </Button>
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {isPaperVisible && (
              <>
                <Grid container spacing={3} my={5} p={4}>
                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          Client / Beneficiaries
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          select
                          size="small"
                          sx={{ flexGrow: 1, width: "100%" }}
                          value={selectedClientPerent || ""}
                          onChange={handleIsClientPerent}
                          InputLabelProps={{ shrink: true }}
                        >
                          <MenuItem value="policyOwner">Policy Owner</MenuItem>
                          <MenuItem value="Insured">Insured</MenuItem>
                          <MenuItem value="Beneficiary">Beneficiary</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                          <MenuItem value="all">All</MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          Client Type
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <FormControl fullWidth size="small">
                          <Select
                            multiple
                            MenuProps={MenuProps}
                            value={selectedClient}
                            // className={classes.searchTextField}
                            onChange={(
                              event: SelectChangeEvent<typeof selectedClient>
                            ) => {
                              const { value } = event.target;
                              setSelectedClient(
                                typeof value === "string"
                                  ? value.split(",").map(Number)
                                  : value
                              );
                            }}
                            renderValue={(selected) =>
                              selected
                                .map((id) => {
                                  const item = cliendList.find(
                                    (c) => c.id === id
                                  );
                                  return item ? item.client_type : id;
                                })
                                .join(", ")
                            }
                          >
                            <MenuItem>
                              <Checkbox
                                checked={
                                  selectedClient.length === cliendList.length
                                }
                                onChange={hadelSelectAllClitntType}
                              />
                              <ListItemText primary="Select All" />
                            </MenuItem>
                            {cliendList &&
                              cliendList.map((category) => (
                                <MenuItem key={category.id} value={category.id}>
                                  <Checkbox
                                    checked={
                                      selectedClient.indexOf(category.id) > -1
                                    }
                                  />
                                  <ListItemText
                                    primary={category.client_type}
                                  />
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          Policy Type
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <FormControl fullWidth size="small">
                          <Select
                            multiple
                            MenuProps={MenuProps}
                            value={selectedPolicy}
                            // className={classes.searchTextField}
                            onChange={(
                              event: SelectChangeEvent<typeof selectedPolicy>
                            ) => {
                              const { value } = event.target;
                              setSelectedPolicy(
                                typeof value === "string"
                                  ? value.split(",").map(Number)
                                  : value
                              );
                            }}
                            renderValue={(selected) =>
                              selected
                                .map((id) => {
                                  const item = policyDataList.find(
                                    (c) => c.id === id
                                  );
                                  return item ? item.policyNumber : id;
                                })
                                .join(", ")
                            }
                          >
                            <MenuItem>
                              <Checkbox
                                checked={
                                  selectedPolicy.length ===
                                  policyDataList.length
                                }
                                onChange={hadelSelectAllPolicy}
                              />
                              <ListItemText primary="Select All" />
                            </MenuItem>
                            {policyDataList &&
                              policyDataList.map((category) => (
                                <MenuItem key={category.id} value={category.id}>
                                  <Checkbox
                                    checked={
                                      selectedPolicy.indexOf(category.id) > -1
                                    }
                                  />
                                  <ListItemText
                                    primary={category.policyNumber}
                                  />
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          Name / E-mail / Mobile Number / Address
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CiSearch
                                  className={classes.searchWidgetIcon2}
                                />
                              </InputAdornment>
                            ),
                            classes: {
                              root: classes.formControlList,
                            },
                          }}
                          fullWidth
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          placeholder="Mobile & Name .."
                          size="small"
                          // className={classes.searchTextField}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box display="flex" justifyContent="flex-end">
                      <Button
                        variant="outlined"
                        startIcon={<RestartAltIcon />}
                        className={classes.addButton}
                        onClick={resetFields}
                      >
                        Reset
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </>
            )}

            <Grid>
              <Grid
                item
                sx={{ width: "100%", pb: 5, borderTop: 2, pt: 3 }}
                className={classes.titleGrid}
              >
                {/* <DataGrid
                  rows={formattedRows}
                  columns={columns}
                  getRowId={(row) => row.id}
                  autoHeight
                  pagination
                  initialState={{
                    pagination: { paginationModel: { pageSize: 100 } },
                  }}
                  rowHeight={60}
                  pageSizeOptions={[5, 10, 20, 50, 100]}
                  style={{ height: "100%", width: "100%" }}
                  className={classes.dataGridTable}
                  checkboxSelection
                  disableRowSelectionOnClick
                  onRowSelectionModelChange={handleRowSelection}
                /> */}
                <div style={{ width: "100%" }}>
                  <TablePagination
                    component="div"
                    count={formattedRows.length}
                    page={paginationModel.page}
                    onPageChange={handleChangePage}
                    rowsPerPage={paginationModel.pageSize}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[
                      5,
                      10,
                      20,
                      50,
                      100,
                      formattedRows.length,
                    ]}
                  />
                  <DataGrid
                    rows={formattedRows.slice(
                      paginationModel.page * paginationModel.pageSize,
                      (paginationModel.page + 1) * paginationModel.pageSize
                    )}
                    columns={columns}
                    getRowId={(row) => row.id}
                    autoHeight
                    rowHeight={60}
                    checkboxSelection
                    disableRowSelectionOnClick
                    className={classes.dataGridTable}
                    onRowSelectionModelChange={handleRowSelection}
                    hideFooter
                  />
                  {/* <DataGrid
                    rows={formattedRows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    autoHeight
                    pagination
                    initialState={{
                      pagination: { paginationModel: { pageSize: 100 } },
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    style={{ height: "100%", width: "100%" }}
                    className={classes.dataGridTable}
                    rowHeight={60}
                    checkboxSelection
                    disableRowSelectionOnClick
                    onRowSelectionModelChange={handleRowSelection}
                    getRowClassName={(params) =>
                      params.row.bgColor ? `row-bg-${params.row.id}` : ""
                    }
                  /> */}
                </div>
              </Grid>
            </Grid>

            <Dialog
              open={open}
              onClose={handleClose}
              aria-describedby="alert-dialog-description"
              classes={{ paper: "inherit" }}
              fullScreen={isMobile}
              fullWidth={isMobile}
              maxWidth="lg"
            >
              <Grid className={classes.Dialog}>
                <Grid container spacing={3}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={3}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Card className={classes.card}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, padding: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              pt={2}
                              alignContent={"center"}
                            >
                              <Typography className={classes.cardTitle}>
                                Select Columns to Export
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid container spacing={3} p={"24px"}>
                            <Grid container spacing={3} p={"24px"}>
                              <>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={isAllSelected}
                                        indeterminate={
                                          selectedColumns.length > 0 &&
                                          !isAllSelected
                                        }
                                        onChange={handleSelectAllChange}
                                      />
                                    }
                                    label="Select All"
                                  />
                                </Grid>

                                {allColumns.map((column) => (
                                  <Grid
                                    item
                                    lg={3}
                                    md={3}
                                    sm={12}
                                    xs={12}
                                    key={column}
                                  >
                                    <FormControlLabel
                                      key={column}
                                      control={
                                        <Checkbox
                                          checked={selectedColumns.includes(
                                            column
                                          )}
                                          onChange={() =>
                                            handleCheckboxChange(column)
                                          }
                                        />
                                      }
                                      label={column}
                                    />
                                  </Grid>
                                ))}
                              </>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Card className={classes.card}>
                          <Grid container spacing={3} p={"24px"}>
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                variant="outlined"
                                startIcon={<CloseIcon />}
                                className={classes.addButton}
                                onClick={handleClose}
                              >
                                Cancel
                              </Button>
                              <Box m={0.5}></Box>

                              <Button
                                variant="contained"
                                startIcon={<TableViewIcon />}
                                className={classes.addButton}
                                onClick={handleExport}
                                disabled={selectedColumns.length === 0}
                              >
                                Export
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Dialog>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
